<template>
  <div>
    <b-modal
      id="excel-modal-center"
      centered
      hide-footer
      hide-header
      @show="removeExcelFromPopUp"
      class="qb-add-ques-modal"
      no-stacking
      no-close-on-backdrop
      :visible="addedMultiple"
      @hidden="(addedMultiple = false), $bvModal.hide('excel-modal-center')"
    >
      <div class="p-0">
        <div>
          <!-- <div  class="xMarkCancel">
            <img src="../../../assets/xmark.svg" alt="" />
          </div>
          <div class="modalheading">Add Multiple Candidates</div> -->
          <div class="cs-modal-header">
            <div>Add Multiple Candidates</div>
            <div @click="closeExcelModal()">
              <img
                class="rotate-on-hover"
                src="../../../assets/img/accessconnew/blueCross.svg"
                alt=""
              />
            </div>
          </div>
          <div
            v-if="excelFile == null"
            class="d-flex justify-content-center pt-2"
          >
            <div
              class="
                d-flex
                align-items-center
                justify-content-center
                flex-column
                position-relative
                mt-4
                ml-0
              "
              :class="
                (!excelFile && errorFile == false) ||
                (excelFile && errorFile == false)
                  ? 'uploadExcel-design'
                  : 'validation-uploadExcel-design'
              "
            >
              <div class="h-100 w-100">
                <b-form-file
                  @input="handleClick"
                  v-model="excelFile"
                  ref="excel-upload-input"
                  class="mb-2"
                  accept=".xlsx, .xls"
                >
                </b-form-file>
                <div
                  v-if="!excelFile"
                  class="
                    d-flex
                    align-items-center
                    justify-content-center
                    flex-column
                    h-100
                    w-100
                  "
                >
                  <div>
                    <img src="../../../assets/talentpool/addPage.svg" alt="" />
                  </div>

                  <div class="cf-card-head mt-2">Drag & Drop file</div>
                  <div class="downloadExcel-subtxt mt-1">(OR)</div>
                  <div class="downloadExcel-txt mt-1">
                    <span style="color: #20639b; font-size: 14px"
                      >Browse file</span
                    >
                    here from your computer
                  </div>
                </div>
                <div
                  v-else-if="excelFile && errorFile == false"
                  class="
                    fedbck-filenamebox
                    d-flex
                    align-items-center
                    justify-content-between
                    style-excel-format
                  "
                >
                  <div
                    class="fedbck-filetextname text-truncate text-width-adjust"
                  >
                    {{ excelFile.name }}
                  </div>
                  <div @click.stop="removeExcelFile" class="pointer">
                    <img
                      src="../../../assets/img/createjd/fedbckclose.svg"
                      alt=""
                    />
                  </div>
                </div>
                <div
                  v-else-if="excelFile"
                  class="
                    fedbck-filenamebox
                    d-flex
                    align-items-center
                    justify-content-between
                    style-excel-format
                  "
                >
                  <div class="asterik mt-2">Please upload supported format</div>
                  <div @click.stop="removeErrorFile" class="pointer">
                    <img
                      src="../../../assets/img/createjd/fedbckclose.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="
              uploadfile-container
              d-flex
              flex-column
              align-items-center
              pt-2
              pl-3
              pr-3
              w-100
              position-relative
            "
            v-if="excelFile && errorFile == false"
          >
            <div
              style="width: 80%"
              class="
                d-flex
                justify-content-between
                align-items-center
                mt-1
                tp-upload-div
              "
            >
              <div
                class="
                  modalheading
                  d-flex
                  align-items-center
                  w-75
                  text-truncate
                "
              >
                <img
                  class="mr-2"
                  src="../../../assets/talentpool/excel.svg"
                  alt=""
                />{{ excelFile.name }}
              </div>

              <div class="d-flex">
                <div class="mr-2 position-relative ucdSelDocFile">
                  <img
                    class="pointer"
                    src="../../../assets/talentpool/replace.svg"
                    alt=""
                  />
                  <b-form-file
                    @input="handleClick"
                    v-model="excelFile"
                    ref="excel-upload-input"
                    class="mb-2"
                    accept=".xlsx, .xls"
                  ></b-form-file>
                </div>
                <img
                  src="../../../assets/talentpool/Deletefile.svg"
                  alt=""
                  class="pointer"
                  @click="removeExcelFile"
                />
              </div>
            </div>
            <div
              style="width: 80%"
              class="mt-2 relativeclass tp-upload-div pb-3"
            >
              <div class="tp-upload-div-text">File.xl</div>
              <div class="tp-upload-div-text-2 mt-2">
                Select Sheet <span class="asterik">*</span>
              </div>
              <div
                class="
                  pointer
                  section-content
                  d-flex
                  justify-content-between
                  align-items-center
                "
                @click="showselecteddropdown = !showselecteddropdown"
              >
                <div class="newManage-dropdown-place">
                  <div>
                    <span
                      class="sbox-subtext cj-noofrecoption"
                      v-if="excelSheetNameShow != 0"
                    >
                      {{ excelSheetNameShow.length }} sheet(s) selected
                    </span>

                    <div v-else>Choose sheets</div>
                  </div>
                </div>

                <div class="pointer" v-if="showselecteddropdown">
                  <img
                    src="../../../assets/talentpool/blueuparrow.svg"
                    alt=""
                  />
                </div>
                <div class="pointer" v-else>
                  <img
                    src="../../../assets/talentpool/bluedownarrow.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="vendor-dropdown-container" v-if="showselecteddropdown">
              <div class="relativeclass aoeinput">
                <template v-if="excelSheetName.length > 1">
                  <div class="aoesearchicon-pos">
                    <img
                      src="../../../assets/img/accesscontrol/inputsearch.svg"
                      alt=""
                    />
                  </div>
                  <b-form-input
                    class="input-field"
                    type="search"
                    placeholder="Search"
                    v-model="searchexcelsheets"
                  >
                  </b-form-input>
                </template>
                <div class="vendor-height-dropdown-container">
                  <b-form-group v-if="excelSheetNamesearch.length > 0">
                    <b-form-checkbox
                      class="qb-dropdown-option-sing pointer"
                      :class="
                        excelSheetNameShow == option &&
                        'qb-dropdown-option-selected'
                      "
                      size="sm"
                      v-model="excelSheetNameShow"
                      v-for="option in excelSheetNamesearch"
                      :key="option"
                      :value="option"
                      @change="searchexcelsheets = ''"
                    >
                      {{ option }}
                    </b-form-checkbox>
                  </b-form-group>

                  <div
                    v-else
                    class="
                      d-flex
                      align-items-center
                      justify-content-center
                      cf-light-txt-3
                      p-3
                    "
                  >
                    No Matching results found for "<b>{{ searchexcelsheets }}</b
                    >"
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="
            mt-4
            mb-4
            dashboardAdmin-cards-subhead-2
            d-flex
            justify-content-center
            align-items-start
          "
        >
          <img
            class="mr-2"
            src="../../../assets/talentpool/alertsmall.svg"
            alt=""
          />
          <div>
            Click on download template button to fill out candidate <br />
            details and upload the file
          </div>
        </div>

        <div
          class="
            mt-3
            d-flex
            justify-content-between
            border-top
            pt-2
            pb-2
            pr-4
            bluebtn
            pl-2
          "
        >
          <div>
            <b-button
              variant="outline"
              class="cursor-pointer"
              @click="downloadMultipleTemplate()"
            >
              <span
                ><img src="../../../assets/talentpool/download.svg" alt=""
              /></span>
              <span class="ml-2 downloadTmplateText">Download Template</span>
            </b-button>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <div
              class="
                acs-cancelBtn-modal
                w-95px
                d-flex
                justify-content-center
                pointer
              "
              @click="closeExcelModal()"
            >
              Back
            </div>
            <div class="position-relative ml-3">
              <b-button
                :disabled="uploadDisable"
                class="acs-addBtn-modal w-95px"
                @click="uploadExcel"
                :class="
                  LoaderStatus ? 'upload-loader-class defaultCursor' : 'pointer'
                "
                >{{ showExcelSpinner ? "" : "Upload" }}</b-button
              >
              <div v-if="showExcelSpinner" class="upload-loader-pos">
                <Loader />
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- this modal is uploaded candidates through excel -->
    <MultiExcelCandidate
      v-if="checkMultipleCandidates"
      :particularJob="particularJob"
      :multiExcelCands="multiExcelCands"
      :showModal="checkMultipleCandidates"
      :failedExcCandidates="failedExcCandidates"
      :passedExcCandidates="passedExcCandidates"
      @stop-spinner="$emit('stop-spinner')"
      @show-add-cands="showAddCandidate"
      @close-jd-modals="$emit('close-jd-modals')"
      @close-modal="closeExcelModal(), (checkMultipleCandidates = false)"
      @update-talent-pool="callTalentPoolApi"
    />
  </div>
</template>

<script>
const XLSX = require("xlsx");

import toast from "../../../components/mixin/toast";
import { downloadTemplate, uploadExcel } from "../../../utils/apiFunctions";
import { isExcel } from "../../../utils/checkFiletype.js";
import Loader from "../../../components/fixedcomponents/Loader.vue";
import MultiExcelCandidate from "./MultiExcelCandidate.vue";
export default {
  name: "AddMultipleExcelModal",
  data() {
    return {
      addedMultiple: this.addMultipleCandidates,
      checkMultipleCandidates: this.checkMultiple,
      LoaderStatus: false,
      passedExcCandidates: [],
      failedExcCandidates: [],
      excelSheetNameShow: [],
      excelSheetName: [],
      searchexcelsheets: "",
      resumeUploaded: 0,
      excelFile: null,
      errorFile: false,
      showExcelSpinner: false,
      showselecteddropdown: false,
      tabIndex: 0,
    };
  },
  props: {
    multiExcelCands: Object,
    addMultipleCandidates: Boolean,
    checkMultiple: Boolean,
    particularJob: Object,
  },
  mixins: [toast],
  components: {
    Loader,
    MultiExcelCandidate,
  },
  computed: {
    uploadDisable() {
      return this.excelFile === null || this.excelSheetNameShow.length === 0;
    },
    excelSheetNamesearch() {
      return this.excelSheetName.filter((data) => {
        return (
          !this.searchexcelsheets ||
          data.toLowerCase().includes(this.searchexcelsheets.toLowerCase())
        );
      });
    },
  },
  methods: {
    showAddCandidate(candidates) {
      this.$emit("show-add-candidate", candidates);
    },
    handleMainAddedMultiple(newVal) {
      this.addedMultiple = newVal;
      this.$emit("closeAddedMultipleExcelCand", this.addedMultiple);
    },
    handleCheckMultipleExcelCand(newVal) {
      this.checkMultipleCandidates = newVal;
      this.$emit("closeExcel", this.checkMultipleCandidates);
    },
    invokeFunctionInParent() {
      // Emit an event to notify the parent to invoke a function
      this.$emit("invokeFunctionInParent");
    },
    // FUNCTION FOR UPLOADING EXCEL AND POPULATING FAILED AND PASSED CANDIDATES ARRAY
    async uploadExcel() {
      try {
        this.showExcelSpinner = true;
        this.LoaderStatus = true;
        let form = new FormData();
        form.append("excel", this.excelFile);
        form.append("sheetName", JSON.stringify(this.excelSheetNameShow));
        if (this.$route.name === "Kanban") {
          form.append("jobID", this.particularJob.jobID);
          form.append("customerID", this.particularJob.customerID);
        }
        if (this.$route.name == "VendorKanban") {
          form.append("jobID", this.particularJob.jobID);
          form.append("customerID", this.particularJob.customerID);
          form.append("vendorID", this.$route.params.vendorID);
        }
        const res = await uploadExcel(form);
        this.showselecteddropdown = false;
        if (res.status == 200) {
          this.LoaderStatus = false;
          this.passedExcCandidates = res.data.data.passedCandidates;
          this.failedExcCandidates = res.data.data.failedCandidates;
          if (res.data.data.S3link) {
            const link = res.data.data.S3link;
            const fileName = `AddCandidateTemplate.xlsx`;
            const a = document.createElement("a");
            a.href = link;
            a.download = fileName;
            a.click();
          }
          if (
            this.passedExcCandidates.length === 0 &&
            this.failedExcCandidates.length > 0
          ) {
            this.tabIndex = 1;
          }
          this.checkMultipleCandidates = true;
        } else {
          this.LoaderStatus = false;
          this.errorModal(res.data.data.details);
        }
        this.showExcelSpinner = false;
        this.removeExcelFromPopUp();
      } catch (error) {
        this.showExcelSpinner = false;
        this.LoaderStatus = false;
        throw new Error(`Failed! To Add Candidates!${error}`);
      }
    },

    // REMOVE EXCEL X-MARK
    removeExcelFromPopUp() {
      this.excelFile = null;
      this.excelSheetNameShow = [];
    },
    async downloadMultipleTemplate() {
      try {
        this.LoaderStatus = true;
        const res = await downloadTemplate();
        if (res.status == 200) {
          this.LoaderStatus = false;

          const href = URL.createObjectURL(res.data);

          // create "a" HTML element with href to file & click
          const link = document.createElement("a");
          link.href = href;
          link.setAttribute("download", `AddCandidateTemplate.xlsx`);

          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        }
      } catch (error) {
        this.LoaderStatus = false;
        throw new Error(`Failed! status:${error.status}`);
      }
    },
    removeExcelModal() {
      this.excelFile = null;
      this.excelSheetNameShow = [];
      this.excelSheetName = [];
      this.searchexcelsheets = "";
      this.showselecteddropdown = false;
      this.$forceUpdate();
    },

    closeExcelModal() {
      this.$bvModal.hide("excel-modal-center");
      this.removeExcelModal();
      this.addedMultiple = false;
      this.$emit("input", this.addedMultiple);
    },
    handleClick: function (event) {
      if (event?.name) {
        this.excelSheetNameShow = [];
        this.errorFile = false;
        let parts = event.name.split(".");

        let ext = parts[parts.length - 1];
        if (isExcel(ext)) {
          if (this.excelFile) {
            const reader = new FileReader();
            reader.onload = (e) => {
              const bstr = e.target.result;
              const wb = XLSX.read(bstr, { type: "binary" });
              this.excelSheetName = wb.SheetNames;
              if (this.excelSheetName.length == 1) {
                this.excelSheetNameShow.push(this.excelSheetName[0]);
              }
            };
            reader.readAsBinaryString(this.excelFile);
          }
        } else {
          this.errorFile = true;
        }
      }
    },
    removeExcelFile() {
      this.$bvModal.hide("modal-multi-excel");
      this.excelFile = null;
      this.excelSheetNameShow = [];
      this.excelSheetName = [];
      this.searchexcelsheets = "";
      this.showselecteddropdown = false;
      this.$forceUpdate();
    },
    removeErrorFile() {
      this.excelFile = null;
      this.excelSheetNameShow = [];
      this.excelSheetName = [];
      this.searchexcelsheets = "";
      this.errorFile = false;
      this.$forceUpdate();
    },
    callTalentPoolApi() {
      this.$emit("update-talent-pool");
    },
  },
};
</script>

<style scoped>
.vendor-height-dropdown-container {
  min-height: auto;
  max-height: 70px;
  overflow: auto;
}

.vendor-dropdown-container {
  background: #ffffff;
  border: 0.7px solid rgba(114, 115, 142, 0.5);
  box-shadow: 0px 4px 14px rgb(0 0 0 / 12%);
  border-radius: 5px;
  position: absolute;
  width: 73%;
  z-index: 3;
  top: 168px;
}

.aoesearchicon-pos {
  position: absolute;
  top: 6px;
  left: 5px;
}

.aoeinput > input {
  padding: 0.75rem 1.25rem !important;
  border-radius: unset;
  border: 2px solid #ffffff;
  background-color: #e8eff4;
}

.aoeinput .form-control {
  padding: 0.375rem 1.3rem !important;
}

.secdropdowncolor:nth-child(odd) {
  font-weight: 400;
  font-size: 13px;
  padding: 0.5rem 1.75rem !important;
  color: #545454;
  background: #f4f4f4;
}

.secdropdowncolor:nth-child(even) {
  font-weight: 400;
  font-size: 13px;
  padding: 0.5rem 1.75rem !important;
  color: #545454;
  background: var(--bg-white);
}

.downloadTmplateText {
  font-weight: 600;
  font-size: 13px;
  font-family: "montserrat", sans-serif;
  color: #20639b;
}

.downloadExcel-txt {
  font-family: "montserrat", sans-serif;
  font-weight: 500;
  font-size: 13px;
  color: #3a3c40;
}

.downloadExcel-subtxt {
  font-family: "lato", sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #8e8e8e;
}

.style-excel-format {
  position: absolute;
  top: 35px;
  width: 87%;
}

.text-width-adjust {
  min-width: auto;
  max-width: 100%;
}

.upload-loader-class {
  opacity: 0.5;
  height: 29px;
  width: 95px;
}

.upload-loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: 0px;
}
</style>
